export const DOSSIER_MODES = Object.freeze({
  STANDARD: "standard",
  EXPRESS: "express",
});

export const DOSSIER_MODE_QUERY_PARAM = "mode";

export const normalizeDossierMode = (value) =>
  value === DOSSIER_MODES.EXPRESS ? DOSSIER_MODES.EXPRESS : DOSSIER_MODES.STANDARD;

export const getDossierModeFromSearch = (search = "") => {
  const params = new URLSearchParams(search || "");
  return normalizeDossierMode(params.get(DOSSIER_MODE_QUERY_PARAM));
};

export const buildDossierPath = (pathname = "/dossier", mode = DOSSIER_MODES.STANDARD, hash = "") => {
  const [withoutHash, existingHash = ""] = String(pathname || "/dossier").split("#");
  const [cleanPath] = withoutHash.split("?");
  const resolvedHash = hash || (existingHash ? `#${existingHash}` : "");
  const normalizedMode = normalizeDossierMode(mode);
  const query = normalizedMode === DOSSIER_MODES.EXPRESS ? `?${DOSSIER_MODE_QUERY_PARAM}=${DOSSIER_MODES.EXPRESS}` : "";
  return `${cleanPath || "/dossier"}${query}${resolvedHash}`;
};

export const isExpressDossierMode = (mode) => normalizeDossierMode(mode) === DOSSIER_MODES.EXPRESS;
